import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { init, push } from '@socialgouv/matomo-next';
import { Environment } from './deploymentInfo';
import fetchAPI from './http/fetchAPI';
import fetchUserAttributesCached from './fetchUserAttributesCached';
var MATOMO_URL = 'https://biomage.matomo.cloud';

// To test a staging deployment, you'll need to go to matomo.cloud
// and change the URL there to point to your staging env URL.
// To test locally, just enable the development environemnt.
// The Site Ids are defined in matomo.cloud
var trackingInfo = _defineProperty(_defineProperty(_defineProperty({}, Environment.PRODUCTION, {
  enabled: true,
  siteId: 1,
  containerId: 'lkIodjnO'
}), Environment.STAGING, {
  enabled: false,
  siteId: 2,
  containerId: 'FX7UBNS6'
}), Environment.DEVELOPMENT, {
  enabled: false,
  siteId: 3,
  containerId: 'lS8ZRMXJ'
});
var env = Environment.DEVELOPMENT;
var getTrackingDetails = function getTrackingDetails(e) {
  return _objectSpread({}, trackingInfo[e]);
};
var initTracking = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(environment, cookiesEnabled) {
    var _getTrackingDetails, siteId, enabled, _yield$fetchUserAttri, email, userActivityBody;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // set the environment for the tracking sytem
          env = environment;
          _getTrackingDetails = getTrackingDetails(env), siteId = _getTrackingDetails.siteId, enabled = _getTrackingDetails.enabled;
          if (!(enabled === false)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          _context.next = 6;
          return fetchUserAttributesCached();
        case 6:
          _yield$fetchUserAttri = _context.sent;
          email = _yield$fetchUserAttri.email;
          _context.prev = 8;
          _context.next = 11;
          return fetch("".concat(MATOMO_URL, "/matomo.php"), {
            mode: 'no-cors'
          });
        case 11:
          // set the user ID and then initialize the tracking so it correctly tracks first page.
          push(['setUserId', email]);
          init({
            url: MATOMO_URL,
            siteId: siteId,
            disableCookies: !cookiesEnabled
          });
          _context.next = 20;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](8);
          userActivityBody = {
            email: email,
            siteId: siteId
          }; // send the user page opened activity manually to the tracking system
          _context.next = 20;
          return fetchAPI('/v2/user/tracking', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(userActivityBody)
          });
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8, 15]]);
  }));
  return function initTracking(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// reset the user ID when loggging out
var resetTrackingId = function resetTrackingId() {
  var _getTrackingDetails2 = getTrackingDetails(env),
    enabled = _getTrackingDetails2.enabled;
  if (enabled === false) {
    return;
  }
  push(['resetUserId']);
  // we also force a new visit to be created for the pageviews after logout
  push(['appendToTrackingUrl', 'new_visit=1']);
};
export { initTracking, resetTrackingId, getTrackingDetails };